import { useState, useEffect } from 'react';

/**
 * Custom hook to observe the presence of an element in the DOM.
 * @param {string} elementId - The ID of the element to observe.
 * @returns {{ isElementPresent: boolean, isLoading: boolean }} -
 * Whether the element exists in the DOM and loading state.
 */
const useElementObserver = (elementId) => {
  const [isElementPresent, setIsElementPresent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkElement = () => {
      const element = document.getElementById(elementId);
      setIsElementPresent(!!element);
      setIsLoading(false); // Mark loading as false after first check
    };

    checkElement(); // Initial check

    const observer = new MutationObserver(() => {
      checkElement();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [elementId]);

  return { isElementPresent, isLoading };
};

export default useElementObserver;
